import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './text-image-block.module.scss';
import { TextImageBlockType } from '@/types/text-imgBlock.types';
import FooterButton from '../Footer/components/FooterButton/FooterButton';
import ButtonSimple from '../HeroBlock/components/ButtonSimple/ButtonSimple';
import Link from 'next/link';

const TextImageBlockJet: NextPage<TextImageBlockType> = ({
  className = '',
  button = 'Group',
  device = 'Desktop',
  imgPosition = 'Right',
  title,
  text,
  image,
  imageMob,
  buttonSimpleText,
  buttonSimpleLink,
  buttonFooterText,
  buttonFooterLink,
  changeSides = false,
  listItems,
}) => {
  return (
    <section
      className={[styles.textimageblock, className].join(' ')}
      data-button={button}
      data-device={device}
      data-imgposition={imgPosition}
    >
      <div
        className={`${styles.container} container`}
        data-change-sides={changeSides}
      >
        <section className={styles.text1}>
          {title && (
            <h2
              className={styles.title}
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            ></h2>
          )}
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          ></div>
          {listItems && (
            <ul className={styles.list}>
              {listItems.map((item) => (
                <li key={item.id} className={styles.li}>
                  <div className={styles.iconWrapper}>
                    <Image
                      src="/img/text-imgBlock/check-img.png"
                      alt={image}
                      width={24}
                      height={24}
                    />
                    {item.title}
                  </div>
                </li>
              ))}
            </ul>
          )}
          <div className={styles.buttongroup}>
            {buttonSimpleText && buttonSimpleLink && (
              <Link
                href="mailto:cw@heraflight.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.submitButtonLink}
              >
                <ButtonSimple
                  className={styles.submitButton}
                  color="accent"
                  highContrast
                  loading={false}
                  size={3}
                  state="default ✦"
                  variant="solid ✦"
                  text={buttonSimpleText}
                  iconStart={false}
                  iconEnd={false}
                  focusRing={false}
                  designBlendingMode="/design--blendingmode1.svg"
                  designBlendingMode1="/design--blendingmode1.svg"
                />
              </Link>
            )}

            {buttonFooterText && buttonFooterLink && (
              <FooterButton
                className={styles.footerButton}
                color="accent"
                highContrast={false}
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text={buttonFooterText}
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                border1={true}
                href={buttonFooterLink}
              />
            )}
          </div>
        </section>
        <Image
          className={styles.imageIcon}
          width={388}
          height={217}
          sizes="100vw"
          alt=""
          src={imageMob}
        />
        <Image
          className={styles.imageIcon1}
          loading="lazy"
          width={1}
          height={1}
          sizes="100vw"
          alt=""
          src={image}
        />
      </div>
    </section>
  );
};

export default TextImageBlockJet;
